/**
 * Created by Ning Jiang on 2/6/2019.
 */

import {BeforeSpinStopPresentationController} from "@nolimitcity/slot-game/bin/core/beforespinstoppresentation/BeforeSpinStopPresentationController";
import {GameConfig} from "@nolimitcity/slot-game/bin/core/gameconfig/GameConfig";
import {IGameConfig} from "@nolimitcity/slot-game/bin/core/gameconfig/IGameConfig";
import {IntroFeatureLogo} from "@nolimitcity/slot-game/bin/core/gameintro/GameIntroView";
import {IGameModuleConfig} from "@nolimitcity/slot-game/bin/core/gamemoduleconfig/IGameModuleConfig";
import {ReelController} from "@nolimitcity/slot-game/bin/core/reel/reel/ReelController";
import {ReelPartAnimator} from "@nolimitcity/slot-game/bin/core/reel/reel/ReelPartAnimator";
import {ReelPartCreator} from "@nolimitcity/slot-game/bin/core/reel/reel/ReelPartCreator";
import {ReelAreaView} from "@nolimitcity/slot-game/bin/core/reel/reelarea/ReelAreaView";
import {Reels} from "@nolimitcity/slot-game/bin/core/reel/reelarea/Reels";
import {ReelStopPresentationController} from "@nolimitcity/slot-game/bin/core/reelstoppresentation/ReelStopPresentationController";
import {ISymbolStateConfig, StateReelSymbol} from "@nolimitcity/slot-game/bin/core/reelsymbol/StateReelSymbol";
import {IResourcesGroupConfig} from "@nolimitcity/slot-game/bin/core/resource/asset/Asset";
import {IFontsConfig} from "@nolimitcity/slot-game/bin/core/resource/font/IFontsConfig";
import {ResourcesGroupName} from "@nolimitcity/slot-game/bin/core/resource/ResourcesGroupName";
import {ISoundConfig} from "@nolimitcity/slot-game/bin/core/resource/sound/ISoundConfig";
import {ScreenController} from "@nolimitcity/slot-game/bin/core/screen/ScreenController";
import {ParsedGameData} from "@nolimitcity/slot-game/bin/core/server/data/ParsedGameData";
import {ParsedInitData} from "@nolimitcity/slot-game/bin/core/server/data/ParsedInitData";
import {ServerDataParser} from "@nolimitcity/slot-game/bin/core/server/ServerDataParser";
import {SpinController} from "@nolimitcity/slot-game/bin/core/spin/SpinController";
import {StageManager} from "@nolimitcity/slot-game/bin/core/stage/StageManager";
import {IndividualWinPresentationController} from "@nolimitcity/slot-game/bin/core/winpresentation/individualwin/IndividualWinPresentationController";
import {WinPresentationController} from "@nolimitcity/slot-game/bin/core/winpresentation/WinPresentationController";
import {ZeroBetController} from "@nolimitcity/slot-game/bin/core/zerobet/ZeroBetController";
import {DirtyWildsLayerConfig} from "../config/DirtyWildsLayerConfig";
import {DirtyWildEffectManager} from "./background/DirtyWildEffectManager";
import {DirtyWildsBetLines} from "./betlines/DirtyWildsBetLines";
import {DirtyWildsFontConfig} from "./DirtyWildsFontConfig";
import {DirtyWildsGameAssets} from "./DirtyWildsGameAssets";
import {DirtyWildsGameConfig} from "./DirtyWildsGameConfig";
import {DirtyWildsSoundConfig} from "./DirtyWildsSoundConfig";
import {DirtyWildsEnvironment} from "./environment/DirtyWildsEnvironment";
import {DirtyWildsRandomFeatureReelStopController} from "./features/DirtyWildsRandomFeatureReelStopController";
import {DirtyWildsRandomTeaseController} from "./features/DirtyWildsRandomTeaseController";
import {DirtyWildsRespinZeroBetController} from "./features/DirtyWildsRespinZeroBetController";
import {DirtyWildsRFSyncController} from "./features/DirtyWildsRFSyncController";
import {DirtyWildsOverlayBeforeStopController} from "./features/overlay/DirtyWildsOverlayBeforeStopController";
import {DirtyWildsOverlayController} from "./features/overlay/DirtyWildsOverlayController";
import {DirtyWildsOverlayReelStopController} from "./features/overlay/DirtyWildsOverlayReelStopController";
import {DirtyWildsTopBarView} from "./features/topBar/DirtyWildsTopBarView";
import {DirtyWildsIntroView} from "./intro/DirtyWildsIntroView";
import {DirtyWildReelPartAnimator} from "./reel/DirtyWildReelPartAnimator";
import {DirtyWildReelView} from "./reel/DirtyWildReelView";
import {DirtyWildsNearWinReelDivider} from "./reel/DirtyWildsNearWinReelDivider";
import {DirtyWildsReelAreaView} from "./reel/DirtyWildsReelAreaView";
import {DirtyWildsReelController} from "./reel/DirtyWildsReelController";
import {DirtyWildsReels} from "./reel/DirtyWildsReels";
import {DirtyWildsFreespinOutroController} from "./screen/DirtyWildsFreespinOutroController";
import {DirtyWildsFreespinOutroView} from "./screen/DirtyWildsFreespinOutroView";
import {DirtyWildsParsedGameData} from "./server/data/DirtyWildsParsedGameData";
import {DirtyWildsParsedInitData} from "./server/data/DirtyWildsParsedInitData";
import {DirtyWildsServerDataParser} from "./server/DirtyWildsServerDataParser";
import {SoundPlayer} from "./soundplayer/SoundPlayer";
import {DirtyWildsSpinController} from "./spin/DirtyWildsSpinController";
import {DirtyWildsStateReelSymbol, DirtyWildsSymbols} from "./symbols/DirtyWildsStateReelSymbol";
import {DirtyWildsWildStateReelSymbol} from "./symbols/DirtyWildsWildStateReelSymbol";
import {DirtyWildsBetLineWinIndividualWPController} from "./winpresentation/DirtyWildsBetLineWinIndividualWPController";
import {DirtyWildsInitialWPController} from "./winpresentation/DirtyWildsInitialWPController";
import {WinCountUpPresentationView} from "./winpresentation/WinCountUpPresentationView";

export class DirtyWildGameModuleConfig implements IGameModuleConfig {

    public static instance:DirtyWildGameModuleConfig = new DirtyWildGameModuleConfig();
    public static soundPlayer:SoundPlayer;
    public static betLines:DirtyWildsBetLines;
    public static effectManager:DirtyWildEffectManager;
    public static topBarView:DirtyWildsTopBarView;
    public static environment:DirtyWildsEnvironment;
    public static overlayController:DirtyWildsOverlayController;
    public static winCountUpPresentation:WinCountUpPresentationView;
    public static reelAreaController:DirtyWildsReels;
    private static reelDivider:DirtyWildsNearWinReelDivider;

    GAME_CONFIG:IGameConfig = DirtyWildsGameConfig.instance;
    SOUND_CONFIG:ISoundConfig = DirtyWildsSoundConfig.instance;
    FONTS_CONFIG:IFontsConfig = DirtyWildsFontConfig.FONTS;
    RESOURCES_CONFIG:IResourcesGroupConfig = DirtyWildsGameAssets.RESOURCES_GROUPS;

    SERVER_PARSER:() => ServerDataParser = () => new DirtyWildsServerDataParser();
    PARSED_INIT_DATA:(data:any, dataParser:ServerDataParser) => ParsedInitData = (data, dataParser:ServerDataParser) => new DirtyWildsParsedInitData(data, <DirtyWildsServerDataParser>dataParser);
    PARSED_GAME_DATA:(data:any, dataParser:ServerDataParser) => ParsedGameData = (data, dataParser:ServerDataParser) => new DirtyWildsParsedGameData(data, <DirtyWildsServerDataParser>dataParser);

    SPIN_CONTROLLER:() => SpinController = () => new DirtyWildsSpinController();

    REEL_AREA_VIEW:() => ReelAreaView = () => new DirtyWildsReelAreaView();

    REEL_CONTROLLER:(reelId:number) => ReelController = reelId => new DirtyWildsReelController(reelId);

    REELS:() => Reels = () => new DirtyWildsReels();

    REEL_VIEW:(reelId:number) => PIXI.Container = reelId => new DirtyWildReelView(reelId);

    REEL_PART_ANIMATOR?:(reelId:number) => ReelPartAnimator = reelId => new DirtyWildReelPartAnimator(reelId);

    REEL_PART_CREATOR:() => ReelPartCreator = () => new ReelPartCreator(
        (symName:string, reelId:number, state?:ISymbolStateConfig):StateReelSymbol => {
            if(symName == DirtyWildsSymbols.W || symName == DirtyWildsSymbols.W_STICKY) {
                return new DirtyWildsWildStateReelSymbol(symName, reelId, state);
            }


            return new DirtyWildsStateReelSymbol(symName, reelId, state);
        });

    INTRO_VIEW:(onClickCallback:() => void) => DirtyWildsIntroView =
        (onClickCallback:() => void) => new DirtyWildsIntroView({
            layer : GameConfig.instance.LAYERS.INTRO.name,
            onButtonClickCallback : onClickCallback,
            resourceGroup : ResourcesGroupName.INTRO,
            backgroundTextures : {
                desktop : {landscape : DirtyWildsGameAssets.INTRO_BACKGROUND},
            },
            featureIcons : {
                icons : [IntroFeatureLogo.VOLATILITY_MEDIUM]
            },
            mobileScale : 1.2,
            portraitScale : 1.7
        });

    SCREENS:(() => ScreenController)[] = [
        () => new DirtyWildsFreespinOutroController({
            viewCreator : (onButtonClickCallback:() => void, autoClose?:boolean) => {
                return new DirtyWildsFreespinOutroView({
                    layer : DirtyWildsLayerConfig.NEAR_WIN_DIV_ATTENTIONS.name,
                    onButtonClickCallback : onButtonClickCallback,
                    buttonBackgroundConfig : {
                        cornerRadius : 12,
                        lineThickness : 2,
                        lineColor : 0xffffff,
                        lineAlpha : 1,
                        backgroundColor : 0x000000,
                        backgroundAlpha : 0.9
                    },
                    mobileScale : 1.2,
                    portraitScale : 1.2
                }, false);
            }
        })
    ];

    ZERO_BETS:(() => ZeroBetController)[] = [
        () => new DirtyWildsRespinZeroBetController()
    ];

    BEFORE_SPIN_STOP_PRESENTATIONS?:((index:number) => BeforeSpinStopPresentationController)[] = [
        (index:number) => new DirtyWildsOverlayBeforeStopController(index, "DirtyWildsOverlayBeforeStopController"),
        (index:number) => new DirtyWildsRFSyncController(index, "DirtyWildsRFSyncController"),
        (index:number) => new DirtyWildsRandomTeaseController(index, "DirtyWildsRandomTeaseController")
    ];

    REEL_STOP_PRESENTATIONS?:((index:number) => ReelStopPresentationController)[] = [
        (index:number) => new DirtyWildsOverlayReelStopController(index, "DirtyWildsOverlayReelStopController"),
        (index:number) => new DirtyWildsRandomFeatureReelStopController(index, "DirtyWildsRandomFeatureReelStopController")
    ];

    WIN_PRESENTATIONS:((indexes:[number, number]) => WinPresentationController)[][] = [
        [indexes => new DirtyWildsInitialWPController(indexes)]
    ];
    INDIVIDUAL_WIN_PRESENTATION:() => IndividualWinPresentationController = () => new DirtyWildsBetLineWinIndividualWPController({
        symbolTimeOffsetCalculator : (currentTotalDuration:number, reelId:number, symbolId:number):number => {
            return 0;
        }
    });

    GAME_FEATURE_CREATOR:() => void = () => {
        DirtyWildGameModuleConfig.overlayController = new DirtyWildsOverlayController();
        DirtyWildGameModuleConfig.environment = new DirtyWildsEnvironment();

        DirtyWildGameModuleConfig.effectManager = new DirtyWildEffectManager();

        DirtyWildGameModuleConfig.soundPlayer = new SoundPlayer();

        DirtyWildGameModuleConfig.topBarView = new DirtyWildsTopBarView();

        DirtyWildGameModuleConfig.betLines = new DirtyWildsBetLines();

        DirtyWildGameModuleConfig.winCountUpPresentation = new WinCountUpPresentationView();

        DirtyWildGameModuleConfig.reelDivider = new DirtyWildsNearWinReelDivider({
            layer : DirtyWildsLayerConfig.NEAR_WIN_DIV_ATTENTIONS.name,
            texturesGetter : (index:number) => {return [PIXI.Texture.EMPTY]},
            positions : [
                [(GameConfig.instance.REEL_AREA_POS_X + GameConfig.instance.SYMBOL_WIDTH / 2 + GameConfig.instance.SYMBOL_WIDTH * 0) - 29, GameConfig.instance.REEL_AREA_POS_Y + 140],
                [(GameConfig.instance.REEL_AREA_POS_X + GameConfig.instance.SYMBOL_WIDTH / 2 + GameConfig.instance.SYMBOL_WIDTH * 1) - 29, GameConfig.instance.REEL_AREA_POS_Y + 140],
                [(GameConfig.instance.REEL_AREA_POS_X + GameConfig.instance.SYMBOL_WIDTH / 2 + GameConfig.instance.SYMBOL_WIDTH * 2) - 29, GameConfig.instance.REEL_AREA_POS_Y + 140],
                [(GameConfig.instance.REEL_AREA_POS_X + GameConfig.instance.SYMBOL_WIDTH / 2 + GameConfig.instance.SYMBOL_WIDTH * 3) - 29, GameConfig.instance.REEL_AREA_POS_Y + 140],
                [(GameConfig.instance.REEL_AREA_POS_X + GameConfig.instance.SYMBOL_WIDTH / 2 + GameConfig.instance.SYMBOL_WIDTH * 4) - 29, GameConfig.instance.REEL_AREA_POS_Y + 140]
            ],
            nearWinLayer : DirtyWildsLayerConfig.NEAR_WIN_DIV_ATTENTIONS.name,
            nearWinTexturesGetter : (index:number) => DirtyWildsGameAssets.getNearWinDividerTextures(index),
            reelIndexMap : [[0], [1], [2], [3], [4]]
        });

        StageManager.legacyScaling = true;
    };


    constructor() {
        if(DirtyWildGameModuleConfig.instance) {
            throw new Error("TombstoneGameModuleConfig.constructor() - Instantiation failed: Singleton.");
        }
    }
}